import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * FirstLoginGuard — R112 (moved here in R113 to fix a rendering-error crash).
 *
 * The original R112 implementation put this redirect inside AuthContext.jsx,
 * but `AuthProvider` wraps `<BrowserRouter>` in App.js, so calling
 * useNavigate/useLocation from AuthContext threw a "Cannot read properties
 * of undefined (reading 'pathname')" error and the whole app fell into
 * the error boundary. Moving the router-dependent logic to this small
 * component that renders INSIDE the router avoids that.
 *
 * Renders nothing. Just watches `user.require_password_change` and pushes
 * the user to /first-login when needed. An exempt list keeps login /
 * reset / first-login itself reachable so the user isn't trapped.
 */
const FIRST_LOGIN_EXEMPT = new Set([
  "/first-login",
  "/reset-password",
  "/login",
  "/forgot-password",
]);

export default function FirstLoginGuard() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || user === false) return;
    if (!user.require_password_change) return;
    if (FIRST_LOGIN_EXEMPT.has(location.pathname)) return;
    navigate("/first-login", { replace: true });
  }, [user, location.pathname, navigate]);

  return null;
}
